var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { PureComponent, createElement } from 'react';
import { default as AntCard } from 'antd/lib/card';
import { ComponentsManager } from '@comall-backend-builder/core';
import { extendsParentProps } from '../component-props';
/**
 * 通用卡片容器
 */

var Card = function (_super) {
  __extends(Card, _super);

  function Card(props) {
    var _this = _super.call(this, props) || this;

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }
  /**
   * 处理按钮的点击事件
   */


  Card.prototype.handleClick = function (event) {
    if (this.props.onClick) {
      this.props.onClick(event);
    }
  };

  Card.prototype.render = function () {
    var _a = this.props,
        title = _a.title,
        style = _a.style,
        className = _a.className,
        bordered = _a.bordered,
        hoverable = _a.hoverable,
        loading = _a.loading,
        bodyStyle = _a.bodyStyle,
        type = _a.type;
    var props = {
      title: title,
      style: style,
      className: className,
      bordered: bordered,
      hoverable: hoverable,
      loading: loading,
      bodyStyle: bodyStyle,
      type: type,
      onClick: this.handleClick
    };
    return React.createElement(AntCard, __assign({}, props), this.renderContent());
  };

  Card.prototype.renderContent = function () {
    var _a = this.props.content,
        component = _a.component,
        otherProps = __rest(_a, ["component"]);

    var props = extendsParentProps(otherProps, this.props);
    return createElement(ComponentsManager.get(component), props);
  };

  return Card;
}(PureComponent);

export { Card };